import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { UIRouterModule } from '@uirouter/angular';
import { AccountSharedModule } from 'apps/account/src/account-shared';
import { OrderModule } from 'ngx-order-pipe';
import { AccountManagementModule } from '../../modules/account-management/account-management.module';
import { CommonDeclarationsModule } from '../../modules/common-declarations/common-declarations.module';
import { AppMenuModule } from '../app-menu/app-menu.module';
import { SpacesModule } from '../spaces/spaces.module';
import { MainNavComponent } from './main-nav/main-nav.component';
import { MenuLinkDirective } from './menu-link/menu-link.directive';
import { SubMenuGroupComponent } from './sub-menu-group/sub-menu-group.component';
import { SubMenuComponent } from './sub-menu/sub-menu.component';
import { PermissionsModule } from 'account-hybrid/common/components/permissions/permissions.module';


@NgModule({
  imports: [
    AccountSharedModule,
    CommonModule,
    SpacesModule,
    AppMenuModule,
    CommonDeclarationsModule,
    AccountManagementModule,
    UIRouterModule.forChild({}),
    OrderModule,
    MatIconModule,
    PermissionsModule
  ],
    declarations: [
        MainNavComponent,
        MenuLinkDirective,
        SubMenuGroupComponent,
        SubMenuComponent
    ],
    exports: [
        MainNavComponent
    ]
})
export class NavModule {

}

